import { render } from "./EditIcon.vue?vue&type=template&id=22ce2fba"
import script from "./EditIcon.vue?vue&type=script&lang=js"
export * from "./EditIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/Icons/EditIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22ce2fba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22ce2fba', __exports__)) {
    console.log('reload')
    api.reload('22ce2fba', __exports__)
  }
  
  module.hot.accept("./EditIcon.vue?vue&type=template&id=22ce2fba", () => {
    console.log('re-render')
    api.rerender('22ce2fba', render)
  })

}


export default __exports__